<template>
    <div class="card-appartement" v-on:click="clicked">
            <div class="card-appartement--img" :style="{'background-image' : geturl}"></div>
            <div class="card-appartement--title">{{title}}</div>
        </div>
</template>

<script>
export default {
    name:'CardPano',
    props : {
        url : String,
        title : String,
        index : Number,
        callback : Function
    },
    computed : {
        geturl() {
            return ("url('" + this.$props.url+ "')");
        }
    },
    methods: {
        clicked : function ()
        {
            this.callback(this.index);
        }

    },
    mounted() {
    }
}
</script>

<style scoped>

.card-appartement--img::before {
    padding: 6rem;
    content: "";
	display: block;
}

.card-appartement--img {
    background-size: cover;
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
    background-position: center;
    width: 100%;
}

.card-appartement--title {
    color: #343a40;
    font-size: 1.5rem;
    font-weight: 700;
    padding: 1rem;
    font-family: 'Montserrat', sans-serif;
    letter-spacing: -0.08rem;

}

.card-appartement--title--active {
    color: white!important;
    background-color: cadetblue!important;
}

.card-appartement {
    box-shadow: 0px 0px 8px 1px rgba(0,0,0,0.28);
    border-radius: 1.0rem;
    margin: 1.5rem;
    
    transition-duration: 0.2s;

}

.card-appartement:hover {
    transform: scale(1.03);
}

</style>